lmApp
  .controller('MetaController', ['$scope', '$rootScope', '$templateCache', '$compile', '$routeParams', '$location', '$timeout', '$q', 'AssetService', 'MetadataService', 'ToastService', 'ModalWindowService',
    function ($scope, $rootScope, $templateCache, $compile, $routeParams, $location, $timeout, $q, AssetService, MetadataService, ToastService, ModalWindowService) {
      $scope.search = {
        newTitle: ''
      };
      //$scope.offset = 20;
      $scope.loading = false;
      $scope.searchShow = false;

      var _meta = ['genres', 'countries', 'categories', 'studios', 'providers'];

      $scope.getPromises = {
        genres: AssetService.GetGenresCollection,
        countries: AssetService.GetCountriesCollection,
        categories: AssetService.GetCategoryCollection,
        studios: AssetService.GetStudiosCollection,
        providers: AssetService.GetProvidersCollection
      };

      $scope.updatePromises = {
        genres: MetadataService.Genres.UpdateGenre,
        countries: MetadataService.Countries.UpdateCountry,
        studios: MetadataService.Studios.UpdateStudio,
        categories: MetadataService.Categories.UpdateCategory,
        providers: MetadataService.Providers.UpdateProvider
      };

      $scope.createPromises = {
        genres: MetadataService.Genres.CreateGenre,
        countries: MetadataService.Countries.CreateCountry,
        studios: MetadataService.Studios.CreateStudio,
        categories: MetadataService.Categories.CreateCategory,
        providers: MetadataService.Providers.CreateProvider
      };

      $scope.deletePromises = {
        genres: MetadataService.Genres.DeleteGenre,
        countries: MetadataService.Countries.DeleteCountry,
        studios: MetadataService.Studios.DeleteStudio,
        categories: MetadataService.Categories.DeleteCategory,
        providers: MetadataService.Providers.DeleteProvider
      };

      $scope.data = {};

      $scope.getCollections = function () {
        $rootScope.showLinearProgress('#metaLoader');
        $rootScope.loading = true;
        for (var key in $scope.getPromises) {
          (function (meta) {
            $scope.getPromises[meta]()
              .then(function (collection) {
                $rootScope.loading = false;
                $rootScope.hideLinearProgress('#metaLoader');

                $scope.data[meta] = _.orderBy(collection.filter(function (item, index) {
                  item.index = index;
                  if (!item.order) item.order = 0;
                  return item.namespace !== 'epg';
                }), ['order'], ['desc']);
              })
              .catch(function (reason) {
                $rootScope.loading = false;
                $rootScope.hideLinearProgress('#metaLoader');

                $rootScope.debugInfo(reason);
              })
          })(key);
        }
      };

      $scope.setCurrentMeta = function (meta) {
        $scope.currentMeta = meta;
        //$scope.offset = 10;
        $location.search('meta', meta);
      };

      $scope.isCurrentMeta = function (meta) {
        return $scope.currentMeta === meta;
      };

      $scope.showMore = function () {
       // $scope.offset = $scope.data[$scope.currentMeta].length + 1000;
      };

      $scope.deleteItem = function (item) {
        if ($scope.loading) return;

        $scope.loading = true;
        $rootScope.showLinearProgress('#metaLoader');

        $scope.deletePromises[$scope.currentMeta](item.id)
          .then(function () {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#metaLoader');
            ToastService.Small({
              title: $scope.currentMeta.toUpperCase() + ' successfully deleted',
              color: 'green',
              icon: 'tag'
            });

            var index = $scope.data[$scope.currentMeta].indexOf(item);
            if (index !== -1) {
              $scope.data[$scope.currentMeta].splice(index, 1);
            }
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#metaLoader');
            ToastService.Small({
              title: $scope.currentMeta.toUpperCase() + ' delete failed',
              color: 'red',
              icon: 'tag'
            });
            $rootScope.debugInfo(reason);
          });
      };

      $scope.updateItem = function (item) {
        item.error = false;

        if ($scope.loading) return;
        if (!item.title) {
          item.error = true;
          return;
        }

        $scope.loading = true;
        $rootScope.showLinearProgress('#metaLoader');

        $scope.updatePromises[$scope.currentMeta](item.id, item.title, item.order)
          .then(function () {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#metaLoader');
            ToastService.Small({
              title: $scope.currentMeta.toUpperCase() + ' successfully updated',
              color: 'green',
              icon: 'tag'
            });
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#metaLoader');
            ToastService.Small({
              title: $scope.currentMeta.toUpperCase() + ' update failed',
              color: 'red',
              icon: 'tag'
            });
            $rootScope.debugInfo(reason);
          });
      };

      $scope.createItem = function () {
        $scope.error = false;
        if ($scope.loading) return;

        if (!$scope.newTitle) {
          $scope.error = true;
          return;
        }
        $scope.loading = true;
        $rootScope.showLinearProgress('#metaLoader');

        $scope.createPromises[$scope.currentMeta]($scope.newTitle, $scope.newExtId, 0)
          .then(function (item) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#metaLoader');

            ToastService.Small({
              title: $scope.currentMeta.toUpperCase() + ' successfully created',
              color: 'green',
              icon: 'tag'
            });

            $scope.newTitle = '';
            $scope.newExtId = '';

            $scope.data[$scope.currentMeta].unshift(item[Object.keys(item)[0]]);

            if ($scope.win) {
              ModalWindowService.Close($scope.win, true);
            }
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#metaLoader');
            ToastService.Small({
              title: $scope.currentMeta.toUpperCase() + ' creation failed ',
              color: 'red',
              icon: 'tag'
            });
            $rootScope.debugInfo(reason);
          });
      };

      $scope.changeItemPriority = function (items, index, direction) {
        items[index].isOver = false;

        var allQ = {};
        switch (direction) {
          case 'up':
            if (index > 0) {
              for (var i = 0; i < items.length; i++) {
                if (i === index) {
                  items[i].order = i;
                  allQ[i] = $scope.updatePromises[$scope.currentMeta](items[i].id, items[i].title, items[i].order);
                  continue
                }
                if (i === index-1) {
                  items[i].order = i+2;
                  allQ[i] = $scope.updatePromises[$scope.currentMeta]( items[i].id,  items[i].title, items[i].order);
                  continue
                }
                if (items[i].order !== (i+1)) {
                  items[i].order = i+1;
                  allQ[i] = $scope.updatePromises[$scope.currentMeta](items[i].id, items[i].title, items[i].order);
                }
              }
            }

            break;

          case 'down':
            if (index < items.length - 1) {
              for (var i = 0; i < items.length - 1; i++) {
                if (i === index) {
                  items[i].order = i+2;
                  allQ[i] = $scope.updatePromises[$scope.currentMeta](items[i].id, items[i].title, items[i].order);
                  continue
                }
                if (i === index+1) {
                  items[i].order = i;
                  allQ[i] = $scope.updatePromises[$scope.currentMeta]( items[i].id,  items[i].title, items[i].order);
                  continue
                }
                if (items[i].order !== (i+1)) {
                  items[i].order = i+1;
                  allQ[i] = $scope.updatePromises[$scope.currentMeta](items[i].id, items[i].title, items[i].order);
                }
             }
            }
        }

        $scope.loading = true;
        $rootScope.showLinearProgress('#metaLoader');

        for (var i = 0; i < $scope.data[$scope.currentMeta].length; i++) {
          var item = $scope.data[$scope.currentMeta][i];
          item.error = false;

          if (!item.title) {
            item.error = true;
            $scope.loading = false;
            $rootScope.hideLinearProgress('#metaLoader');
            return;
          }
        }

        $q.all(allQ)
          .then(function () {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#metaLoader');
            ToastService.Small({
              title: $scope.currentMeta.toUpperCase() + ' order successfully updated',
              color: 'green',
              icon: 'tag'
            });
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#metaLoader');
            ToastService.Small({
              title: $scope.currentMeta.toUpperCase() + ' order update failed',
              color: 'red',
              icon: 'tag'
            });
            $rootScope.debugInfo(reason);
          });
      };

      $scope.showCreateWindow = function () {
        $scope._createInner_ = $templateCache.get('add-metadata.html');
        $scope.newTitle = angular.copy($scope.search.newTitle);
        $scope._createInner_ = $compile($scope._createInner_)($scope);

        $scope.window = ModalWindowService.Open({
          content: $scope._createInner_,
          size: {
            s: 3
          },
          actions: [
            {
              title: 'Create',
              color: 'lm',
              fn: function () {
                $scope.createItem();
              },
              className: 'btn-ghost'
            },
            {
              title: 'Cancel',
              color: 'grey',
              className: 'btn-ghost'
            }
          ],
          keyboard: true
        });
      };

      $scope.importDefaultMetadata = function (meta) {
        if ($scope.loading) return;

        $scope.loading = true;
        $rootScope.showLinearProgress('#metaLoader');

        MetadataService.ImportMetadata(meta)
          .then(function (response) {
            $scope.loading = false;
            ToastService.Small({
              title: $scope.currentMeta.toUpperCase() + ' imported successfully',
              color: 'green',
              icon: 'arrow-down-bold-hexagon-outline'
            });
            $rootScope.hideLinearProgress('#metaLoader');
            $scope.getCollections();
          })
          .catch(function (reason) {
            $rootScope.debugInfo(reason);
            $scope.loading = false;
            $rootScope.hideLinearProgress('#metaLoader');
            ToastService.Small({
              title: $scope.currentMeta.toUpperCase() + ' import failed',
              color: 'red',
              icon: 'arrow-down-bold-hexagon-outline'
            });
          });
      };

      $scope.$watch('search.newTitle', function (newValue, oldValue) {
       /* if (newValue) {
          $scope.offset = $scope.data[$scope.currentMeta].length;
        } else {
          $scope.offset = 20;
        }*/
      });

      $scope.getCollections();

      if ($routeParams.meta && _meta.indexOf($routeParams.meta) !== -1) {
        $scope.currentMeta = $routeParams.meta;
      } else {
        $scope.currentMeta = 'categories';
        $location.search('meta', 'categories');
      }

      $scope.createLocalizationWindow = function (item, languages, newLocalizationItem) {
        $scope.freeLanguages = {};
        $scope.freeLanguages.list = [];
        languages.list.forEach(function (languageItem) {
          var localizationItem = _.find(item.localization, { language: languageItem.title });
          if (!localizationItem) {
            $scope.freeLanguages.list.push(languageItem);
          }
        });
        $scope._createInner_ = $templateCache.get('add-metadata-localization.html');
        $scope._createInner_ = $compile($scope._createInner_)($scope);
        $scope.window = ModalWindowService.Open({
          content: $scope._createInner_,
          size: {
            s: 3
          },
          actions: [
            {
              title: 'Create',
              color: 'lm',
              fn: function () {
                $scope.createNewLocalization(item, newLocalizationItem);
              },
              className: 'btn-ghost'
            },
            {
              title: 'Cancel',
              color: 'grey',
              className: 'btn-ghost'
            }
          ],
          keyboard: true
        });
      };

      $scope.languages = MetadataService.languages;
      $scope.newLocalizationItem = { language: {}, title: ''};

      $scope.createNewLocalization = function (item, newLocalizationItem) {
        if (newLocalizationItem.language.id && newLocalizationItem.title) {
          var data = {};
          item.localization.forEach(function (localizationItem) {
            var languageItem = _.find($scope.languages.list, { title: localizationItem.language });
            data[languageItem.id] = { title: localizationItem.title };
          });

          var addedLocalizationItem = {};
          addedLocalizationItem[newLocalizationItem.language.id] = { title: newLocalizationItem.title }
          data = Object.assign(data, addedLocalizationItem);

          MetadataService.PatchLocalization($scope.currentMeta, item.id, data).then(function () {
            var localization = {};
            localization.language = newLocalizationItem.language.title;
            localization.title = newLocalizationItem.title;
            item.localization.push(localization);
            $scope.newLocalizationItem = { language: {}, title: '' };
          });
        }
      };

      $scope.checkCurrentMeta = function(item) {
        if ($scope.currentMeta === 'studios' || $scope.currentMeta === 'providers') {
          return;
        }
        $scope.setActiveItem(item);
      };

      $scope.setActiveItem = function (item) {
        $scope.activeItem = item;
        $scope.activeItem.localization = [];
        if (item.isActive) {
          item.isActive = false;
          return;
        } else {
          item.isActive = true;
          item.tab = 'localization';
          MetadataService.GetLocalization($scope.currentMeta, item.id).then(function (response) {
            for (var localizationItem in response.data) {
              var language = _.find($scope.languages.list, { id: localizationItem });
              var localization = {};
              localization.language = language.title;
              localization.title = response.data[localizationItem].title;
              $scope.activeItem.localization.push(localization);
            }
          });
        }
      };

      $scope.isActiveItem = function (item) {
        return item.isActive;
      };

      $scope.unsetActiveItem = function (item) {
        item.isActive = false;
      };

      $scope.deleteLocalizationItem = function (item, deletedIndex) {
        item.localization.splice(deletedIndex, 1);
        var data = {};
        item.localization.forEach(function (localizationItem) {
          var languageItem = _.find($scope.languages.list, { title: localizationItem.language });
          data[languageItem.id] = { title: localizationItem.title };
        });
        MetadataService.PatchLocalization($scope.currentMeta, item.id, data);
      };

      $scope.isCurrentTab = function (item, tab) {
        return item.tab === tab;
      };

      $scope.setCurrentTab = function (item, tab) {
        item.tab = tab;
      };
    }
  ]);
